"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePermission = exports.createPermission = exports.havePermission = exports.permissionsNamespace = void 0;
exports.permissionsNamespace = 'client-dashboard';
/**
 * Validates given permission list agains required permission.
 *
 * Rules:
 *  * Namespaces must be the same.
 *  * Resources must be the same . Given resources supports `*` for any match (if `*` is the end of resource - recursive match is applied). Required resource does not support `*`.
 *  * Actions must be the same. Given permissions supports `*` for any permission, required permission does not.
 */
function havePermission(have, required) {
    const requiredParts = required.resource.split('/');
    return have
        .filter((v) => v.namespace === required.namespace)
        .some(({ resource, action }) => {
        const haveResourceParts = resource.split('/');
        // If resources does not end with '*' they must be the same length
        if (haveResourceParts[haveResourceParts.length - 1] !== '*' &&
            haveResourceParts.length !== requiredParts.length) {
            return false;
        }
        // If resources ends with * validate correct length
        if (haveResourceParts[haveResourceParts.length - 1] === '*' &&
            requiredParts.length < haveResourceParts.length) {
            return false;
        }
        if (haveResourceParts.every((havePart, index) => {
            return (havePart === '*' && !!requiredParts[index]) || havePart === requiredParts[index];
        })) {
            return action === '*' || required.action === '*' || required.action === action;
        }
        return false;
    });
}
exports.havePermission = havePermission;
/**
 *
 * @param namespace - permissions namespace
 */
function createPermission({ action, resource, namespace = exports.permissionsNamespace }) {
    return {
        action,
        namespace,
        resource: resource instanceof Array ? resource.map((v) => encodeURIComponent(v)).join('/') : resource,
    };
}
exports.createPermission = createPermission;
/**
 * Parses permissions string(e.g. `namespace:resource/path:action`) to `Permission` object.
 */
function parsePermission(value) {
    const parts = value.split(':');
    if (![2, 3].includes(parts.length)) {
        throw Error('Malformed permissions');
    }
    return {
        namespace: parts[0],
        resource: parts[1],
        action: parts[2] || '*',
    };
}
exports.parsePermission = parsePermission;
